<template>
  <div id="app">
    <div id="nav">
      <ResponsiveNavigation
        :nav-links="navLinks"
        :image-path="require('./assets/logo.png')"
      />
    </div>
    <!-- /nav -->
    <router-view />
  </div>
</template>

<script>
import ResponsiveNavigation from "@/components/ResponsiveNavigation";
import axios from "axios";

export default {
  components: {
    ResponsiveNavigation
  },
  data: () => ({
    navLinks: {
      email: "",
      fb: "",
      ig: "",
      li: ""
    }
  }),
  methods: {
    getSocialNetworks() {
      var self = this;

      axios
        .get("https://api.blue-temple.com/configuration")
        .then(function(res) {
          var fb_url = res.data.data.filter(obj => {
            return obj.key === "Social_Facebook";
          });
          self.navLinks.fb = fb_url[0].defaultValue;
          //
          var ig_url = res.data.data.filter(obj => {
            return obj.key === "Social_Instagram";
          });
          self.navLinks.ig = ig_url[0].defaultValue;
          //
          var li_url = res.data.data.filter(obj => {
            return obj.key === "Social_Linkedin";
          });
          self.navLinks.li = li_url[0].defaultValue;

          var email_url = res.data.data.filter(obj => {
            return obj.key === "Social_Mail";
          });
          self.navLinks.email = email_url[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    }
  },
  created: function() {
    this.getSocialNetworks();
  }
};
</script>

<style lang="scss">
#app {
  font-family: "rajdhanilight";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 {
  display: block;
  font-family: "rajdhanilight";
  font-weight: normal;
  text-transform: uppercase;
  color: $color-light;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
    }
  }
}

@media screen and (min-device-width: 768px) {
  #app {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    background: $color-darkgrey;
  }

  .home {
    #app {
      // background: url("./assets/images/bg.jpg");
      // background-size: cover;
      // background-position: top left;
      background-color: rgb(46,46,47);
    }
  }

  #nav {
    width: 25vw;
    height: 100vh;
  }

  h1 {
    font-size: 27px;
  }
}
</style>
